document.addEventListener('DOMContentLoaded', function() {
  console.log('Product arrows script loaded');
    
  // Find the product media container - using more specific selectors based on your theme
  const mediaGallery = document.querySelector('media-gallery');
  if (!mediaGallery) {
    console.log('No media gallery found');
    return;
  }
    
  // Find the viewer inside the media gallery
  const galleryViewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
  if (!galleryViewer) {
    console.log('No gallery viewer found');
    return;
  }
    
  console.log('Found gallery viewer:', galleryViewer);
    
  // Create and insert the arrow buttons directly on the gallery viewer
  const arrowContainer = document.createElement('div');
  arrowContainer.className = 'custom-product-arrows';
  arrowContainer.style.position = 'absolute';
  arrowContainer.style.top = '50%';
  arrowContainer.style.left = '0';
  arrowContainer.style.right = '0';
  arrowContainer.style.transform = 'translateY(-50%)';
  arrowContainer.style.display = 'flex';
  arrowContainer.style.justifyContent = 'space-between';
  arrowContainer.style.padding = '0 20px';
  // Stay below .section-header's stacking context (z-index: 3) so the mobile
  // nav overlay naturally covers these arrows when the drawer opens.
  arrowContainer.style.zIndex = '2';
  arrowContainer.style.pointerEvents = 'none';
  arrowContainer.style.width = '100%';
    
  // Create left arrow button with inline styles
  const prevButton = document.createElement('button');
  prevButton.className = 'custom-arrow-btn custom-arrow-prev';
  prevButton.setAttribute('aria-label', 'Previous image');
  prevButton.innerHTML = '<svg viewBox="0 0 24 24"><path d="M15 6L9 12L15 18" stroke="white" stroke-width="2" fill="none"></path></svg>';
  prevButton.style.backgroundColor = 'rgba(0, 0, 0, 0.3)';
  prevButton.style.borderRadius = '50%';
  prevButton.style.width = '40px';
  prevButton.style.height = '40px';
  prevButton.style.display = 'flex';
  prevButton.style.alignItems = 'center';
  prevButton.style.justifyContent = 'center';
  prevButton.style.cursor = 'pointer';
  prevButton.style.border = 'none';
  prevButton.style.pointerEvents = 'auto';
  prevButton.style.boxShadow = '0 0 5px rgba(0, 0, 0, 0.3)';
    
  // Create right arrow button with inline styles
  const nextButton = document.createElement('button');
  nextButton.className = 'custom-arrow-btn custom-arrow-next';
  nextButton.setAttribute('aria-label', 'Next image');
  nextButton.innerHTML = '<svg viewBox="0 0 24 24"><path d="M9 6L15 12L9 18" stroke="white" stroke-width="2" fill="none"></path></svg>';
  nextButton.style.backgroundColor = 'rgba(0, 0, 0, 0.3)';
  nextButton.style.borderRadius = '50%';
  nextButton.style.width = '40px';
  nextButton.style.height = '40px';
  nextButton.style.display = 'flex';
  nextButton.style.alignItems = 'center';
  nextButton.style.justifyContent = 'center';
  nextButton.style.cursor = 'pointer';
  nextButton.style.border = 'none';
  nextButton.style.pointerEvents = 'auto';
  nextButton.style.boxShadow = '0 0 5px rgba(0, 0, 0, 0.3)';
    
  // Add buttons to container
  arrowContainer.appendChild(prevButton);
  arrowContainer.appendChild(nextButton);
    
  // Make sure the gallery viewer has position relative
  galleryViewer.style.position = 'relative';
    
  // Add the arrow container to the gallery viewer
  galleryViewer.appendChild(arrowContainer);
  console.log('Added arrow container to gallery viewer');
    
  // Find the slider within the gallery
  const slider = galleryViewer.querySelector('ul');
  if (!slider) {
    console.log('No slider found in gallery viewer');
    return;
  }
    
  console.log('Found slider:', slider);
    
  // Get navigable slides (respects color-group filtering)
  const usesColorGroups = !!mediaGallery.dataset.deferVariantMedia;
  function getVisibleSlides() {
    const allSlides = Array.from(slider.querySelectorAll('li'));
    if (usesColorGroups) {
      // Filter by color-active class — on desktop only the active slide has display != none,
      // but all slides for the current color have the color-active class
      return allSlides.filter(s => s.classList.contains('color-active'));
    }
    return allSlides;
  }

  // Verify at least one slide exists before attaching handlers
  if (!getVisibleSlides().length) {
    console.log('No slides found in slider');
    return;
  }

  console.log(`Found ${getVisibleSlides().length} visible slides`);

  // Function to show a specific slide
  function showSlide(delta) {
    // Always re-derive the current state from live DOM to avoid stale index
    // after color variant switches (which reorder/filter slides without
    // arrow code being notified reliably via the old observer approach).
    const slides = getVisibleSlides();
    if (!slides.length) return;

    // Find the currently active slide in the live set
    let activeIdx = 0;
    for (let i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) {
        activeIdx = i;
        break;
      }
    }

    let targetIdx = activeIdx + delta;

    // Handle wraparound
    if (targetIdx < 0) targetIdx = slides.length - 1;
    if (targetIdx >= slides.length) targetIdx = 0;

    const targetSlide = slides[targetIdx];
    const mediaId = targetSlide?.dataset?.mediaId;
    if (!mediaId) return;

    // Call setActiveMedia directly on the media-gallery custom element.
    // Thumbnail button clicks don't work for template-hydrated thumbnails
    // because media-gallery.js binds handlers in its constructor before
    // deferred templates are unpacked.
    if (typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(mediaId, false);
    }
  }
    
  // Add click handlers
  prevButton.addEventListener('click', function(e) {
    e.preventDefault();
    console.log('Previous button clicked');
    showSlide(-1);
  });

  nextButton.addEventListener('click', function(e) {
    e.preventDefault();
    console.log('Next button clicked');
    showSlide(1);
  });
    
  console.log('Arrow navigation initialization complete');
});